import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';

function PaymentPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const [selectedMethod, setSelectedMethod] = useState(null);
  const [loading, setLoading] = useState(false);

  // Get the booking ID passed from the previous page
  const bookingId = location.state?.bookingId;

  const showAccount = (method) => {
    setSelectedMethod(method);
  };

  const handleConfirmPayment = () => {
    if (!bookingId) {
      alert("Error: No booking selected.");
      return;
    }

    setLoading(true);
    // Update Backend Status to 'Paid'
    axios.put(`process.env.REACT_APP_API_BASE_URL/bookings/cancel/${bookingId}`, { status: 'Paid' }) // Reusing the unified update route
      .then(res => {
        alert("Payment Recorded! Waiting for admin verification.");
        navigate('/my-appointments');
      })
      .catch(err => {
        console.error(err);
        alert("Error processing payment update.");
      })
      .finally(() => setLoading(false));
  };

  // WhatsApp Link for screenshot (Manual Verification)
  const whatsappLink = "https://wa.me/923498016392?text=I%20have%20paid%20for%20Booking%20ID:%20" + (bookingId || 'Unknown');

  return (
    <div className="payment-page-body">
      <div className="container d-flex justify-content-center align-items-center min-vh-100">

        <div className="payment-card p-4 col-md-6 bg-white">
          <h3 className="text-center mb-4">Complete Your Payment</h3>

          {/* Payment Options */}
          <div className="d-grid gap-3">
            <button className="btn btn-success btn-option" onClick={() => showAccount('Easypaisa')}>Easypaisa</button>
            <button className="btn btn-warning btn-option" onClick={() => showAccount('JazzCash')}>JazzCash</button>
          </div>

          {/* Account Details Box */}
          {selectedMethod && (
            <div id="accountBox" className="account-box mt-4 fade-in">
              <h5 className="text-primary">{selectedMethod} Payment</h5>
              <hr />
              <p className="mb-1"><strong>Account Number:</strong> 03498016392</p>
              <h5 className="fw-bold">Title: Syed Hassan Shah</h5>
              <p className="small text-muted">Please send the consultation fee to this number.</p>

              <div className="d-grid gap-2 mt-3">
                {/* Step 1: Send Proof */}
                <a href={whatsappLink} target="_blank" rel="noreferrer" className="btn btn-outline-success">
                  <i className="bi bi-whatsapp me-2"></i> 1. Send Screenshot
                </a>

                {/* Step 2: Confirm in App */}
                <button
                  onClick={handleConfirmPayment}
                  className="btn btn-primary fw-bold"
                  disabled={loading}
                >
                  {loading ? 'Processing...' : '2. Click Here after Payment'}
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default PaymentPage;